import React from "react";
import { connect } from "react-redux";
import { userActions } from "../../redux/_actions";
import axios from "axios";
import severUrl from "../../api";
import FaceBookLoginForm from "./FaceBookLoginForm";
import GoogleAuth from './GoogleAuth';


class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        password: "",
        username: "",
      },
      errorMessage: {
        username: null,
        password: null,
        email: null,
        non_field_errors: null,
      },
      errorMsg: null,
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleGoogleLoginSuccess(response) {
    // Handle successful Google login (e.g., save user data, redirect, etc.)
    window.location.href = '\account'
  };

  handleGoogleLoginFailure(error){
    // Handle failed Google login
    console.error('Google login error:', error);
  };

  handleChange(event) {
    const { name, value } = event.target;
    const { user } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value,
      },
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ submitted: true });
    const { user } = this.state;
    if (user.username && user.password) {
      // this.props.register(user);
      // console.log(user);
      var bodyFormData = new FormData();
      bodyFormData.append("username", user.username);
      // bodyFormData.append("email", user.email);
      bodyFormData.append("password", user.password);
      axios
        .post(severUrl + `registration/login_user`, bodyFormData)
        .then((response) => {
          // console.log(response.data.result);
          localStorage.setItem("user", JSON.stringify(response.data));
          window.location.reload();
        }).catch(error => {
          console.error('There was an error!', error.response.data);
          this.setState({ errorMsg: error.response.data.message })
        });
    }
  }

  _handleKeyPress(e) {
    if (e.key === "Enter") {
      this.handleSubmit(e)
    }
  }

  render() {
    const { registering } = this.props;
    const { user, errorMessage, submitted } = this.state;
    return (
      <div className="form-style-6">
        <form name="form" onSubmit={this.handleSubmit}>
          {/* <div className={'form-group' + (submitted && !user.email ? ' has-error' : '')}>
            <label htmlFor="email">Email</label>
            <input type="email" className="form-control" name="email" value={user.email} onChange={this.handleChange} />
            {submitted && !user.email &&
              <div className="help-block">Email is required</div>
            }
          </div> */}
          <div
            className={
              "form-group" + (submitted && !user.username ? " has-error" : "")
            }
          >
            <label htmlFor="username">Username</label>
            <input
              type="text"
              className="form-control"
              name="username"
              value={user.username}
              onChange={this.handleChange}
            />
            {submitted && !user.username && (
              <div className="help-block">Username is required</div>
            )}
          </div>
          {submitted && errorMessage.username != null && (
            <div className="help-block">{errorMessage.username}</div>
          )}
          <div
            className={
              "form-group" + (submitted && !user.password ? " has-error" : "")
            }
          >
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              value={user.password}
              onChange={this.handleChange}
              onKeyDown={(e) => this._handleKeyPress(e)}
            />
            {submitted && !user.password && (
              <div className="help-block">Password is required</div>
            )}
            {submitted && errorMessage.password != null && (
              <div className="help-block">{errorMessage.password}</div>
            )}
          </div>
          {submitted && this.state.errorMsg != null && (
            <div className="help-block" style={{ color: "red" }}>{this.state.errorMsg}</div>
          )}
          <div className="form-group">
            <button
              onClick={this.handleSubmit}
              type="submit"
              form="form"
              className="button-3"
            >
              Log In
            </button>
            {registering && (
              <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            )}
          </div>
        </form>
        <p style={{fontSize:"12px"}}>OR</p>
        <div style={{width:"100%"}}>
        <FaceBookLoginForm />
        <GoogleAuth onSuccess={(e) => this.handleGoogleLoginSuccess(e)} onFailure={(e) => this.handleGoogleLoginFailure(e)} /></div>
      </div>
    );
  }
}

function mapState(state) {
  const { registering } = state.registration;
  return { registering };
}

const actionCreators = {
  register: userActions.register,
};

const connectedRegisterPage = connect(mapState, actionCreators)(LoginForm);
export { connectedRegisterPage as LoginForm };